import { trackButtonClick } from '../../../analytics';

export default function CTA() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Course Image */}
        <div className="max-w-4xl mx-auto mb-12">
          <img
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/bb81daf869b00bf1e657e03b1c8d360f.jpeg"
            alt="AI Creator Course"
            className="w-full"
          />
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a
            href="/checkout"
            className="inline-block bg-green-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:bg-green-700 transition-all whitespace-nowrap cursor-pointer"
            onClick={() => trackButtonClick('enroll_today', 'cta_section')}
          >
            Click Here To Enroll Today!
          </a>
        </div>
      </div>
    </section>
  );
}
